import IndexV2 from "@/pages/IndexV2";

const Index = () => <IndexV2 />;

export default Index;
